(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    function getCountdownParts(milliseconds) {
      var totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      return [
        { value: pad(days), label: 'D' },
        { value: pad(hours), label: 'H' },
        { value: pad(minutes), label: 'M' },
        { value: pad(seconds), label: 'S' }
      ];
    }

    function appendTextElement(parent, className, text) {
      var element = document.createElement('span');
      element.className = className;
      element.textContent = text;
      parent.appendChild(element);
      return element;
    }

    function updateCountdown(countdown) {
      var endValue = countdown.dataset.countdownEnd;
      var endTime = Date.parse(endValue);

      if (!endValue || Number.isNaN(endTime)) {
        countdown.hidden = true;
        return;
      }

      var prefix = countdown.dataset.countdownPrefix || '';
      var parts = getCountdownParts(endTime - Date.now());
      var spokenParts = [];

      countdown.textContent = '';
      countdown.hidden = false;

      if (prefix) appendTextElement(countdown, 'announcement-bar__countdown-prefix', prefix);

      parts.forEach(function (part, index) {
        var unit = document.createElement('span');
        unit.className = 'announcement-bar__countdown-unit';

        appendTextElement(unit, 'announcement-bar__countdown-value', part.value);
        appendTextElement(unit, 'announcement-bar__countdown-label', part.label);
        countdown.appendChild(unit);
        spokenParts.push(part.value + part.label);

        if (index < parts.length - 1) {
          appendTextElement(countdown, 'announcement-bar__countdown-separator', ':');
        }
      });

      countdown.setAttribute('aria-label', (prefix ? prefix + ' ' : '') + spokenParts.join(' '));
    }

    function setupCountdowns(root) {
      root.querySelectorAll('[data-announcement-countdown]').forEach(function (countdown) {
        updateCountdown(countdown);
      });

      if (window.announcementBarCountdownTimer) return;

      window.announcementBarCountdownTimer = window.setInterval(function () {
        document.querySelectorAll('[data-announcement-countdown]').forEach(updateCountdown);
      }, 1000);
    }

    function setupAnnouncementBars() {
      var bars = document.querySelectorAll('[data-announcement-bar]');

      bars.forEach(function (bar) {
        var storageKey = bar.getAttribute('data-announcement-bar-key');

        try {
          if (storageKey && window.sessionStorage.getItem(storageKey) === 'closed') {
            bar.hidden = true;
            return;
          }
        } catch (error) {
        }

        setupCountdowns(bar);

        var closeButton = bar.querySelector('[data-announcement-bar-close]');
        if (closeButton && closeButton.dataset.announcementBarBound !== 'true') {
          closeButton.dataset.announcementBarBound = 'true';
          closeButton.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            bar.hidden = true;

            try {
              if (storageKey) window.sessionStorage.setItem(storageKey, 'closed');
            } catch (error) {
            }
          });
        }

        if (bar.announcementCarouselCleanup) {
          bar.announcementCarouselCleanup();
          bar.announcementCarouselCleanup = undefined;
        }

        var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-announcement-slide]'));
        var activeIndex = slides.findIndex(function (slide) {
          return slide.classList.contains('is-active');
        });
        if (activeIndex < 0) activeIndex = 0;

        function updateSurfaceStyle() {
          var activeSlide = slides[activeIndex];
          bar.classList.toggle(
            'is-countdown-active',
            Boolean(activeSlide && activeSlide.dataset.announcementHasCountdown === 'true')
          );
        }

        function showSlide(index) {
          activeIndex = (index + slides.length) % slides.length;
          slides.forEach(function (slide, slideIndex) {
            slide.classList.toggle('is-active', slideIndex === activeIndex);
          });
          updateSurfaceStyle();
        }

        updateSurfaceStyle();
        if (slides.length <= 1) return;

        var intervalDuration = Number.parseInt(bar.dataset.announcementInterval, 10);
        if (!Number.isFinite(intervalDuration) || intervalDuration < 3000) intervalDuration = 5000;

        var timer;
        function start() {
          stop();
          timer = window.setInterval(function () {
            showSlide(activeIndex + 1);
          }, intervalDuration);
        }

        function stop() {
          if (!timer) return;
          window.clearInterval(timer);
          timer = undefined;
        }

        var cleanupCallbacks = [];
        function bind(target, eventName, handler) {
          target.addEventListener(eventName, handler);
          cleanupCallbacks.push(function () {
            target.removeEventListener(eventName, handler);
          });
        }

        if (bar.dataset.announcementPauseOnHover === 'true') {
          bind(bar, 'mouseenter', stop);
          bind(bar, 'mouseleave', start);
          bind(bar, 'focusin', stop);
          bind(bar, 'focusout', start);
        }

        function getSelectedSlide(event) {
          var selectedSlide = null;
          if (event.target && typeof event.target.closest === 'function') {
            selectedSlide = event.target.closest('[data-announcement-slide]');
          }
          if (selectedSlide && bar.contains(selectedSlide)) return selectedSlide;

          var blockId = event.detail && event.detail.blockId;
          if (!blockId) return null;

          return slides.find(function (slide) {
            return slide.dataset.announcementBlockId === blockId;
          });
        }

        function handleBlockSelect(event) {
          var selectedSlide = getSelectedSlide(event);
          if (!selectedSlide || !bar.contains(selectedSlide)) return;
          var selectedIndex = slides.indexOf(selectedSlide);
          if (selectedIndex < 0) return;
          stop();
          showSlide(selectedIndex);
        }

        bind(document, 'shopify:block:select', handleBlockSelect);
        bind(document, 'shopify:block:deselect', start);

        bar.dataset.announcementCarouselBound = 'true';
        bar.announcementCarouselCleanup = function () {
          stop();
          cleanupCallbacks.forEach(function (cleanup) {
            cleanup();
          });
        };
        start();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAnnouncementBars);
    } else {
      setupAnnouncementBars();
    }

    document.addEventListener('shopify:section:load', setupAnnouncementBars);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-launch-gift"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('homepage-launch-gift-gallery')) {
    class HomepageLaunchGiftGallery extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-gallery-ready')) return;

        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-gallery-index]'));
        this.activeIndex = 0;
        this.scrollFrame = null;

        if (!this.viewport || this.slides.length < 2) return;

        this.setAttribute('data-gallery-ready', '');

        this.querySelectorAll('[data-gallery-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            this.show(this.activeIndex + Number(button.dataset.galleryDirection));
          });
        });

        this.dots.forEach((button) => {
          button.addEventListener('click', () => {
            this.show(Number(button.dataset.galleryIndex));
          });
        });

        this.viewport.addEventListener(
          'scroll',
          () => {
            if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = requestAnimationFrame(() => this.updateFromScroll());
          },
          { passive: true }
        );

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.show(this.activeIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.activeIndex + 1);
          }
        });
      }

      show(index) {
        const nextIndex = (index + this.slides.length) % this.slides.length;
        this.viewport.scrollTo({
          left: this.slides[nextIndex].offsetLeft,
          behavior: 'smooth'
        });
        this.update(nextIndex);
      }

      updateFromScroll() {
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - this.viewport.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.update(closestIndex);
      }

      update(index) {
        this.activeIndex = index;

        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
        });

        this.dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      }
    }

    customElements.define('homepage-launch-gift-gallery', HomepageLaunchGiftGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-campaign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initLaunchCampaign = (root) => {
      const sticky = root.querySelector('[data-launch-sticky-cta]');
      const hero = root.querySelector('.launch-campaign__hero');
      if (!sticky || !hero || sticky.dataset.bound === 'true') return;

      sticky.dataset.bound = 'true';
      const toggleSticky = () => {
        sticky.classList.toggle('is-visible', window.scrollY > hero.offsetHeight * 0.65);
      };

      window.addEventListener('scroll', toggleSticky, { passive: true });
      toggleSticky();
    };

    initLaunchCampaign(document);
    document.addEventListener('shopify:section:load', (event) => initLaunchCampaign(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  ;(function() {
    function addHiddenInput(form, name, value, className) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value || '';
      if (className) input.className = className;
      form.appendChild(input);
      return input;
    }

    function ensureRuntimeStyle() {
      if (document.getElementById('as-runtime-shop-pay-style')) return;
      var style = document.createElement('style');
      style.id = 'as-runtime-shop-pay-style';
      style.textContent = '.as-runtime-shop-pay-wrap{margin-top:.5rem;width:100%}.as-runtime-shop-pay-form{margin:0}.as-runtime-shop-pay-wrap .shopify-payment-button,.as-runtime-shop-pay-wrap .shopify-payment-button__button{width:100%}';
      document.head.appendChild(style);
    }

    function refreshPaymentButton() {
      if (!window.Shopify || !window.Shopify.PaymentButton || typeof window.Shopify.PaymentButton.init !== 'function') return;
      window.Shopify.PaymentButton.init();
    }

    function normalizeShopPayButtons() {
      var changed = false;
      var wraps = document.querySelectorAll('.as-unified-shop-pay-wrap');

      wraps.forEach(function(wrap, index) {
        if (wrap.querySelector('form.as-unified-shop-pay-form')) return;
        if (wrap.closest('form.as-unified-shop-pay-form')) return;

        var sourceForm = wrap.closest('form[action*="/cart/add"]');
        if (!sourceForm) return;

        var paymentButton = wrap.querySelector('[data-shopify="payment-button"]');
        var variantInput = sourceForm.querySelector('input[name="id"], input[name="items[0]id"]');
        var quantityInput = sourceForm.querySelector('input[name="quantity"], input[name="items[0]quantity"]');
        if (!paymentButton || !variantInput || !variantInput.value) return;

        ensureRuntimeStyle();

        var runtimeWrap = document.createElement('div');
        runtimeWrap.className = wrap.className + ' as-runtime-shop-pay-wrap';

        var runtimeForm = document.createElement('form');
        runtimeForm.method = sourceForm.method || 'post';
        runtimeForm.action = sourceForm.getAttribute('action') || '/cart/add';
        runtimeForm.acceptCharset = 'UTF-8';
        runtimeForm.enctype = 'multipart/form-data';
        runtimeForm.noValidate = true;
        runtimeForm.setAttribute('novalidate', 'novalidate');
        runtimeForm.className = 'form as-unified-shop-pay-form as-runtime-shop-pay-form';
        runtimeForm.id = (sourceForm.id || 'as-product-form-' + index) + '-shop-pay';

        addHiddenInput(runtimeForm, 'form_type', 'product');
        addHiddenInput(runtimeForm, 'utf8', '\u2713');
        addHiddenInput(runtimeForm, 'id', variantInput.value, 'as-unified-variant-id as-unified-shop-pay-variant-id');
        addHiddenInput(runtimeForm, 'quantity', quantityInput && quantityInput.value ? quantityInput.value : '1', 'as-unified-quantity as-unified-shop-pay-quantity');

        ['product-id', 'section-id'].forEach(function(name) {
          var sourceInput = sourceForm.querySelector('input[name="' + name + '"]');
          if (sourceInput) addHiddenInput(runtimeForm, name, sourceInput.value);
        });

        runtimeForm.appendChild(paymentButton);
        runtimeWrap.appendChild(runtimeForm);

        var host = sourceForm.closest('product-form') || sourceForm;
        if (!host.parentNode) return;
        host.parentNode.insertBefore(runtimeWrap, host.nextSibling);

        var oldRow = wrap.closest('.as-unified-secondary-row');
        wrap.remove();
        if (oldRow && !oldRow.querySelector('.as-unified-shop-pay-wrap, .as-unified-amazon-btn')) {
          oldRow.remove();
        }

        changed = true;
      });

      if (changed) window.setTimeout(refreshPaymentButton, 0);
    }

    normalizeShopPayButtons();
    document.addEventListener('DOMContentLoaded', normalizeShopPayButtons);
    document.addEventListener('change', function(event) {
      if (!event.target.matches('.as-product-variant, .as-form-control-number')) return;
      window.setTimeout(normalizeShopPayButtons, 0);
    });
  })()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-main-product-v1-script')
  if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
    window.productV1 = $url.value
    var $script = document.createElement('script')
    $script.src = window.productV1
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-media-cards-script')
  if (!window.mediaCards && $url && $url.dataset.designMode !== 'yes') {
    window.mediaCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.mediaCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-quotes"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-media-quotes-script')
  if (!window.mediaCards && $url && $url.dataset.designMode !== 'yes') {
    window.mediaCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.mediaCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-bonus-intake"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
    const CAMPAIGN_RULES_REFRESH_MS = 5 * 60 * 1000;
    const CAMPAIGN_RULES_RETRY_MS = 60 * 1000;

    const initGiftCarousel = (section) => {
      const carousel = section.querySelector('[data-order-bonus-gift-carousel]');
      if (!carousel || carousel.dataset.orderBonusGiftInitialized === 'true') return;
      carousel.dataset.orderBonusGiftInitialized = 'true';

      const viewport = carousel.querySelector('[data-order-bonus-gift-viewport]');
      const track = carousel.querySelector('[data-order-bonus-gift-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-order-bonus-gift-slide]'));
      const indicators = Array.from(carousel.querySelectorAll('[data-order-bonus-gift-indicator]'));
      const status = carousel.querySelector('[data-order-bonus-gift-status]');
      const previous = carousel.querySelector('[data-order-bonus-gift-prev]');
      const next = carousel.querySelector('[data-order-bonus-gift-next]');
      if (!viewport || !track || slides.length < 2) return;

      let activeIndex = Math.min(Number(carousel.dataset.defaultSlide || 0), slides.length - 1);
      let touchStartX = null;

      const showSlide = (requestedIndex) => {
        activeIndex = (requestedIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${activeIndex * 100}%)`;
        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
        });
        indicators.forEach((indicator, index) => {
          indicator.classList.toggle('is-active', index === activeIndex);
        });
        if (status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
      };

      previous?.addEventListener('click', () => showSlide(activeIndex - 1));
      next?.addEventListener('click', () => showSlide(activeIndex + 1));

      viewport.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX ?? null;
      }, { passive: true });
      viewport.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
        const distance = touchEndX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 40) return;
        showSlide(activeIndex + (distance < 0 ? 1 : -1));
      }, { passive: true });

      showSlide(activeIndex);
    };

    const initSection = (section) => {
      if (!section || section.dataset.orderBonusInitialized === 'true') return;
      section.dataset.orderBonusInitialized = 'true';

      initGiftCarousel(section);

      const form = section.querySelector('[data-order-bonus-form]');
      if (!form) return;

      const formAnchor = section.querySelector('[data-order-bonus-form-anchor]');
      const scrollButtons = section.querySelectorAll('[data-order-bonus-scroll]');
      const applyButtons = section.querySelectorAll('[data-order-bonus-apply-button]');
      const purchaseDate = form.querySelector('[data-order-bonus-purchase-date]');
      const dateControl = form.querySelector('[data-order-bonus-date-control]');
      const dateToggle = form.querySelector('[data-order-bonus-date-toggle]');
      const dateCalendar = form.querySelector('[data-order-bonus-calendar]');
      const dateCalendarTitle = form.querySelector('[data-order-bonus-calendar-title]');
      const dateCalendarGrid = form.querySelector('[data-order-bonus-calendar-grid]');
      const dateCalendarPrev = form.querySelector('[data-order-bonus-calendar-prev]');
      const dateCalendarNext = form.querySelector('[data-order-bonus-calendar-next]');
      const storeDetail = form.querySelector('[data-order-bonus-store-detail]');
      const quantity = form.querySelector('[data-order-bonus-quantity]');
      const serialList = form.querySelector('[data-order-bonus-serial-list]');
      const serialTemplate = form.querySelector('[data-order-bonus-serial-template]');
      const serialCount = form.querySelector('[data-order-bonus-serial-count]');
      const email = form.querySelector('[data-order-bonus-email]');
      const emailConfirmation = form.querySelector('[data-order-bonus-email-confirmation]');
      const proof = form.querySelector('[data-order-bonus-proof]');
      const submitButton = form.querySelector('[data-order-bonus-submit]');
      const response = form.querySelector('[data-order-bonus-response]');
      const applicationLock = section.querySelector('[data-order-bonus-application-lock]');
      const applicationLockHeading = section.querySelector('[data-order-bonus-application-lock-heading]');
      const applicationLockMessage = section.querySelector('[data-order-bonus-application-lock-message]');
      const previewBanner = section.querySelector('[data-order-bonus-preview-banner]');
      const modal = section.querySelector('[data-order-bonus-rules-modal]');
      const modalOpen = section.querySelector('[data-order-bonus-rules-open]');
      const modalCloseButtons = section.querySelectorAll('[data-order-bonus-rules-close]');
      const serialGuideModal = section.querySelector('[data-order-bonus-serial-guide-modal]');
      const serialGuideOpen = section.querySelector('[data-order-bonus-serial-guide-open]');
      const serialGuideClose = section.querySelector('[data-order-bonus-serial-guide-close]');
      const submissionReady = section.dataset.submissionReady === 'true';
      const submissionEndpoint = section.dataset.submissionEndpoint || '';
      const submissionTestMode = section.dataset.submissionTestMode === 'true';
      const pendingRequests = new Map();
      let isSubmitting = false;
      let lastFocusedElement = null;
      let serialGuideLastFocusedElement = null;
      let campaignRulesState = 'loading';
      let campaignPhases = [];
      let campaignRulesTimer = null;

      const normalizeCampaignPhase = (phase) => {
        const applicationStartMs = Date.parse(String(phase.applicationStart || ''));
        const applicationEndMs = Date.parse(String(phase.applicationEnd || ''));
        const purchaseStart = String(phase.purchaseStart || '');
        const purchaseEnd = String(phase.purchaseEnd || '');
        if (
          !/^\d{4}-\d{2}-\d{2}$/.test(purchaseStart) ||
          !/^\d{4}-\d{2}-\d{2}$/.test(purchaseEnd) ||
          purchaseStart > purchaseEnd ||
          !Number.isFinite(applicationStartMs) ||
          !Number.isFinite(applicationEndMs)
        ) return null;

        return {
          phaseId: String(phase.phaseId || ''),
          purchaseStart,
          purchaseEnd,
          applicationStartMs,
          applicationEndMs
        };
      };

      const getJapanTodayIso = () => {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Asia/Tokyo',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).formatToParts(new Date());
        const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
        return `${values.year}-${values.month}-${values.day}`;
      };

      const getActiveCampaignPhases = () => {
        const now = Date.now();
        return campaignPhases.filter((phase) => (
          submissionTestMode || (now >= phase.applicationStartMs && now <= phase.applicationEndMs)
        ));
      };

      const getEligibleCampaignPhase = (isoDate) => {
        if (!isoDate || isoDate > getJapanTodayIso()) return null;
        return getActiveCampaignPhases().find((phase) => (
          isoDate >= phase.purchaseStart && isoDate <= phase.purchaseEnd
        )) || null;
      };

      const getApplicationState = () => {
        if (campaignRulesState === 'loading') return 'loading';
        if (campaignRulesState === 'unavailable') return 'unavailable';
        if (submissionTestMode && campaignPhases.length) return 'open';

        const now = Date.now();
        if (campaignPhases.some((phase) => now >= phase.applicationStartMs && now <= phase.applicationEndMs)) {
          return 'open';
        }
        if (campaignPhases.some((phase) => now < phase.applicationStartMs)) return 'not_started';
        return 'closed';
      };

      const isApplicationLocked = () => getApplicationState() !== 'open';

      const rememberInitialDisabledState = (control) => {
        if (control.dataset.orderBonusInitiallyDisabled) return;
        control.dataset.orderBonusInitiallyDisabled = control.disabled ? 'true' : 'false';
      };

      const applyApplicationLockState = () => {
        const applicationState = getApplicationState();
        const locked = applicationState !== 'open';
        const closed = applicationState === 'closed';
        const loading = applicationState === 'loading';
        const unavailable = applicationState === 'unavailable';
        const lockedLabel = loading
          ? section.dataset.campaignRulesLoadingLabel
          : unavailable
            ? section.dataset.campaignRulesUnavailableLabel
            : closed
              ? section.dataset.applicationClosedLabel
              : section.dataset.applicationLockedLabel;

        form.classList.toggle('is-locked', locked);

        if (applicationLock) {
          applicationLock.hidden = !locked;
          applicationLock.classList.toggle('is-closed', closed);
        }
        if (applicationLockHeading) {
          applicationLockHeading.textContent = loading
            ? section.dataset.campaignRulesLoadingHeading
            : unavailable
              ? section.dataset.campaignRulesUnavailableHeading
              : closed
                ? section.dataset.applicationClosedHeading
                : section.dataset.applicationLockedHeading;
        }
        if (applicationLockMessage) {
          applicationLockMessage.textContent = loading
            ? section.dataset.campaignRulesLoadingMessage
            : unavailable
              ? section.dataset.campaignRulesUnavailableMessage
              : closed
                ? section.dataset.applicationClosedMessage
                : section.dataset.applicationLockedMessage;
        }
        if (previewBanner && !submissionReady) previewBanner.hidden = locked;

        form.querySelectorAll('input, select, textarea, button').forEach((control) => {
          rememberInitialDisabledState(control);
          if (!locked && control === submitButton) return;
          control.disabled = locked || control.dataset.orderBonusInitiallyDisabled === 'true';
        });

        applyButtons.forEach((button) => {
          if (!button.dataset.orderBonusDefaultLabel) button.dataset.orderBonusDefaultLabel = button.textContent.trim();
          button.textContent = locked ? lockedLabel : button.dataset.orderBonusDefaultLabel;
        });

        if (submitButton) {
          if (!submitButton.dataset.orderBonusDefaultLabel) submitButton.dataset.orderBonusDefaultLabel = submitButton.textContent.trim();
          submitButton.textContent = locked ? lockedLabel : submitButton.dataset.orderBonusDefaultLabel;
        }
      };

      const showResponse = (message) => {
        if (!response) return;
        response.textContent = message;
        response.hidden = false;
      };

      const createRequestId = () => {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }
        return `order-bonus-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      };

      const createApplicationId = () => {
        const timestamp = new Date().toISOString().replace(/\D/g, '').slice(0, 14);
        let suffix = Math.random().toString(16).slice(2, 8).toUpperCase().padEnd(6, '0');

        if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
          const bytes = new Uint8Array(3);
          window.crypto.getRandomValues(bytes);
          suffix = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('').toUpperCase();
        }

        return `OB-${timestamp}-${suffix}`;
      };

      const handleSubmissionMessage = (event) => {
        const message = event.data;
        if (!message || message.source !== 'order-bonus-intake' || !message.requestId) return;

        const pending = pendingRequests.get(message.requestId);
        if (!pending) return;

        pendingRequests.delete(message.requestId);
        window.clearTimeout(pending.timeoutId);
        window.setTimeout(pending.cleanup, 0);

        if (message.ok) {
          pending.resolve(message);
        } else {
          const submissionError = new Error(message.message || section.dataset.submissionFailureMessage);
          submissionError.code = message.code || '';
          pending.reject(submissionError);
        }
      };

      window.addEventListener('message', handleSubmissionMessage);

      const postPayload = (payload, timeoutMs = 120000) => new Promise((resolve, reject) => {
        if (!submissionEndpoint) {
          reject(new Error(section.dataset.submissionFailureMessage));
          return;
        }

        const requestId = createRequestId();
        const iframeName = `order-bonus-transport-${requestId.replace(/[^a-zA-Z0-9_-]/g, '')}`;
        const iframe = document.createElement('iframe');
        const transportForm = document.createElement('form');
        const payloadInput = document.createElement('input');

        iframe.name = iframeName;
        iframe.hidden = true;
        iframe.setAttribute('aria-hidden', 'true');

        transportForm.method = 'post';
        transportForm.action = submissionEndpoint;
        transportForm.target = iframeName;
        transportForm.hidden = true;

        payloadInput.type = 'hidden';
        payloadInput.name = 'payload';
        payloadInput.value = JSON.stringify({ ...payload, requestId });
        transportForm.appendChild(payloadInput);

        const cleanup = () => {
          iframe.remove();
          transportForm.remove();
        };
        const timeoutId = window.setTimeout(() => {
          pendingRequests.delete(requestId);
          cleanup();
          reject(new Error(section.dataset.submissionTimeoutMessage));
        }, timeoutMs);

        pendingRequests.set(requestId, { cleanup, reject, resolve, timeoutId });
        document.body.appendChild(iframe);
        document.body.appendChild(transportForm);
        HTMLFormElement.prototype.submit.call(transportForm);
      });

      const scheduleCampaignRulesRefresh = (delay) => {
        if (campaignRulesTimer) window.clearTimeout(campaignRulesTimer);
        campaignRulesTimer = window.setTimeout(loadCampaignRules, delay);
      };

      const loadCampaignRules = async () => {
        if (!submissionReady) {
          campaignRulesState = 'unavailable';
          applyApplicationLockState();
          return;
        }

        try {
          const result = await postPayload({ action: 'campaign_rules' }, 30000);
          const phases = Array.isArray(result.phases)
            ? result.phases.map(normalizeCampaignPhase).filter(Boolean)
            : [];
          if (!result.ok || result.status !== 'campaign_rules' || !phases.length) {
            throw new Error(section.dataset.campaignRulesUnavailableMessage);
          }

          campaignPhases = phases;
          campaignRulesState = 'ready';
          updateCampaignDateBounds();
          applyApplicationLockState();
          validatePurchaseDate();
          renderDateCalendar();
          scheduleCampaignRulesRefresh(CAMPAIGN_RULES_REFRESH_MS);
        } catch (error) {
          campaignRulesState = 'unavailable';
          campaignPhases = [];
          updateCampaignDateBounds();
          applyApplicationLockState();
          validatePurchaseDate();
          scheduleCampaignRulesRefresh(CAMPAIGN_RULES_RETRY_MS);
        }
      };

      const readFile = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          const result = typeof reader.result === 'string' ? reader.result : '';
          const separatorIndex = result.indexOf(',');
          if (separatorIndex < 0) {
            reject(new Error(section.dataset.submissionFailureMessage));
            return;
          }
          resolve({
            name: file.name,
            type: file.type,
            size: file.size,
            data: result.slice(separatorIndex + 1)
          });
        });
        reader.addEventListener('error', () => reject(new Error(section.dataset.submissionFailureMessage)));
        reader.readAsDataURL(file);
      });

      const normalizeSerialValue = (value) => String(value || '')
        .normalize('NFKC')
        .trim()
        .replace(/\s+/g, '')
        .toUpperCase();

      const collectSubmission = () => {
        const formData = new FormData(form);
        const fields = {};

        formData.forEach((value, key) => {
          if (key === 'シリアル番号[]' || value instanceof File) return;
          fields[key] = String(value);
        });

        const serialRows = Array.from(form.querySelectorAll('[data-order-bonus-serial-row]'));
        const serials = serialRows.map((row) => {
          const input = row.querySelector('[data-order-bonus-serial-input]');
          return input ? normalizeSerialValue(input.value) : '';
        });
        const serialPhotos = serialRows
          .map((row, index) => {
            const input = row.querySelector('input[type="file"]');
            return input && input.files && input.files[0]
              ? { detailIndex: index + 1, file: input.files[0] }
              : null;
          })
          .filter(Boolean);

        return {
          fields,
          proofFile: proof && proof.files ? proof.files[0] : null,
          serialPhotos,
          serials
        };
      };

      const setSubmitting = (active) => {
        isSubmitting = active;
        form.setAttribute('aria-busy', active ? 'true' : 'false');

        form.querySelectorAll('input, select, textarea, button').forEach((control) => {
          rememberInitialDisabledState(control);
          control.disabled = active || control.dataset.orderBonusInitiallyDisabled === 'true';
        });

        if (submitButton) {
          if (!submitButton.dataset.orderBonusDefaultLabel) submitButton.dataset.orderBonusDefaultLabel = submitButton.textContent.trim();
          submitButton.textContent = active ? section.dataset.sendingMessage : submitButton.dataset.orderBonusDefaultLabel;
          submitButton.setAttribute('aria-disabled', submitButton.disabled ? 'true' : 'false');
        }

        if (!active) {
          form.removeAttribute('aria-busy');
          applyApplicationLockState();
          validatePurchaseDate();
        }
      };

      const uploadFile = async (applicationId, role, detailIndex, file) => {
        const encodedFile = await readFile(file);
        return postPayload({
          action: 'upload',
          applicationId,
          role,
          detailIndex,
          file: encodedFile
        });
      };

      const formatTemplate = (template, replacements) => Object.entries(replacements).reduce(
        (result, [token, value]) => result.replaceAll(token, String(value)),
        template
      );

      const padDatePart = (value) => String(value).padStart(2, '0');

      const parseDateValue = (value) => {
        const match = /^(\d{4})[/-](\d{1,2})[/-](\d{1,2})$/.exec(String(value || '').trim());
        if (!match) return null;

        const year = Number(match[1]);
        const month = Number(match[2]) - 1;
        const day = Number(match[3]);
        const date = new Date(year, month, day);
        if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) return null;
        return date;
      };

      const formatDateValue = (date) => (
        `${date.getFullYear()}/${padDatePart(date.getMonth() + 1)}/${padDatePart(date.getDate())}`
      );

      const formatIsoDate = (date) => (
        `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}`
      );

      const ensureFieldError = (field) => {
        if (!field || !field.id) return null;

        const errorId = `${field.id}-error`;
        let error = document.getElementById(errorId);
        if (!error) {
          error = document.createElement('p');
          error.id = errorId;
          error.className = 'order-bonus-form__field-error';
          error.dataset.orderBonusFieldError = '';
          error.setAttribute('aria-live', 'polite');
          error.hidden = true;

          const checkboxLabel = field.closest('.order-bonus-form__checkbox');
          const dateFieldControl = field.closest('[data-order-bonus-date-control]');
          const anchor = checkboxLabel || dateFieldControl || field;
          anchor.insertAdjacentElement('afterend', error);
        }

        const describedBy = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        describedBy.add(errorId);
        field.setAttribute('aria-describedby', Array.from(describedBy).join(' '));
        return error;
      };

      const setFieldError = (field, message) => {
        const error = message
          ? ensureFieldError(field)
          : field && field.id
            ? document.getElementById(`${field.id}-error`)
            : null;
        if (message) field.dataset.orderBonusValidationShown = 'true';
        field.setAttribute('aria-invalid', message ? 'true' : 'false');
        if (!error) return;
        error.textContent = message || '';
        error.hidden = !message;
      };

      const getBasicValidityMessage = (field, showRequired = false) => {
        if (!field) return '';
        field.setCustomValidity('');

        const value = typeof field.value === 'string' ? field.value.trim() : '';
        const isEmpty = field.type === 'checkbox'
          ? !field.checked
          : field.type === 'file'
            ? !field.files || !field.files.length
            : !value;

        if (field.required && isEmpty && showRequired) {
          if (field.type === 'checkbox') return section.dataset.requiredCheckboxMessage;
          if (field.type === 'file') return section.dataset.requiredFileMessage;
          if (field.tagName === 'SELECT') return section.dataset.requiredSelectMessage;
          return section.dataset.requiredInputMessage;
        }

        if (isEmpty) return '';
        if (field.validity.typeMismatch && field.type === 'email') return section.dataset.invalidEmailMessage;
        if (field.validity.patternMismatch) return field.title || section.dataset.invalidFormatMessage;
        if (field.validity.badInput || field.validity.rangeOverflow || field.validity.rangeUnderflow || field.validity.stepMismatch) {
          return section.dataset.invalidFormatMessage;
        }
        return '';
      };

      const validateBasicField = (field, showRequired = false) => {
        const message = getBasicValidityMessage(field, showRequired);
        field.setCustomValidity(message);
        setFieldError(field, message);
        return !message;
      };

      const validatePurchaseDate = (showRequired = false, normalizeValue = false) => {
        if (!purchaseDate) return true;

        const dateValue = purchaseDate.value.trim();
        const parsedDate = parseDateValue(dateValue);
        let message = '';

        if (!dateValue && showRequired) {
          message = section.dataset.requiredInputMessage;
        } else if (dateValue && !parsedDate) {
          message = section.dataset.dateFormatMessage;
        } else if (parsedDate) {
          const isoDate = formatIsoDate(parsedDate);
          if (!getEligibleCampaignPhase(isoDate)) {
            message = section.dataset.dateErrorMessage;
          } else if (normalizeValue) {
            purchaseDate.value = formatDateValue(parsedDate);
          }
        }

        purchaseDate.setCustomValidity(message);
        setFieldError(purchaseDate, message);

        if (submitButton) {
          submitButton.disabled = isApplicationLocked() || !submissionReady;
          submitButton.setAttribute('aria-disabled', submitButton.disabled ? 'true' : 'false');
        }

        if (storeDetail) storeDetail.required = true;
        return !message;
      };

      let campaignStartDate = null;
      let purchaseEndDate = null;
      let selectedPurchaseDate = null;
      let dateView = new Date();

      const updateCampaignDateBounds = () => {
        const activePhases = getActiveCampaignPhases();
        const todayJst = getJapanTodayIso();
        const starts = activePhases.map((phase) => phase.purchaseStart).sort();
        const ends = activePhases.map((phase) => phase.purchaseEnd < todayJst ? phase.purchaseEnd : todayJst).sort();
        campaignStartDate = starts.length ? parseDateValue(starts[0]) : null;
        purchaseEndDate = ends.length ? parseDateValue(ends[ends.length - 1]) : null;

        const referenceDate = selectedPurchaseDate || campaignStartDate || new Date();
        dateView = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), 1);
      };

      const closeDateCalendar = () => {
        if (!dateControl || !dateCalendar) return;
        dateControl.classList.remove('is-open');
        dateCalendar.hidden = true;
        if (purchaseDate) purchaseDate.setAttribute('aria-expanded', 'false');
        if (dateToggle) dateToggle.setAttribute('aria-expanded', 'false');
      };

      const renderDateCalendar = () => {
        if (!dateCalendarTitle || !dateCalendarGrid || !dateCalendarPrev || !dateCalendarNext) return;

        const year = dateView.getFullYear();
        const month = dateView.getMonth();
        const firstWeekday = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        dateCalendarTitle.textContent = formatTemplate(section.dataset.calendarMonthTemplate, {
          __YEAR__: year,
          __MONTH__: month + 1
        });
        dateCalendarGrid.innerHTML = '';

        for (let emptyIndex = 0; emptyIndex < firstWeekday; emptyIndex += 1) {
          const empty = document.createElement('span');
          empty.className = 'order-bonus-form__calendar-empty';
          dateCalendarGrid.appendChild(empty);
        }

        for (let day = 1; day <= daysInMonth; day += 1) {
          const dayDate = new Date(year, month, day);
          const isoDate = formatIsoDate(dayDate);
          const button = document.createElement('button');
          button.className = 'order-bonus-form__calendar-day';
          button.type = 'button';
          button.textContent = String(day);
          button.setAttribute('aria-label', formatDateValue(dayDate));
          button.disabled = !getEligibleCampaignPhase(isoDate);

          if (selectedPurchaseDate && formatIsoDate(selectedPurchaseDate) === isoDate) {
            button.classList.add('is-selected');
            button.setAttribute('aria-current', 'date');
          }

          button.addEventListener('click', () => {
            selectedPurchaseDate = dayDate;
            purchaseDate.value = formatDateValue(dayDate);
            validatePurchaseDate(true, true);
            closeDateCalendar();
            purchaseDate.focus();
          });

          dateCalendarGrid.appendChild(button);
        }

        if (!campaignStartDate || !purchaseEndDate) {
          dateCalendarPrev.disabled = true;
          dateCalendarNext.disabled = true;
          return;
        }
        const minMonth = campaignStartDate.getFullYear() * 12 + campaignStartDate.getMonth();
        const maxMonth = purchaseEndDate.getFullYear() * 12 + purchaseEndDate.getMonth();
        const currentMonth = year * 12 + month;
        dateCalendarPrev.disabled = currentMonth <= minMonth;
        dateCalendarNext.disabled = currentMonth >= maxMonth;
      };

      const openDateCalendar = () => {
        if (!dateControl || !dateCalendar || !purchaseDate || !dateToggle) return;
        selectedPurchaseDate = parseDateValue(purchaseDate.value);
        const referenceDate = selectedPurchaseDate || campaignStartDate || new Date();
        dateView = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), 1);
        renderDateCalendar();
        dateControl.classList.add('is-open');
        dateCalendar.hidden = false;
        purchaseDate.setAttribute('aria-expanded', 'true');
        dateToggle.setAttribute('aria-expanded', 'true');
      };

      const updateSerialRows = () => {
        if (!quantity || !serialList || !serialTemplate) return;
        const targetCount = Number(quantity.value);
        if (!Number.isInteger(targetCount) || targetCount < 1 || targetCount > 10) return;

        let rows = Array.from(serialList.querySelectorAll('[data-order-bonus-serial-row]'));
        while (rows.length < targetCount) {
          serialList.appendChild(serialTemplate.content.cloneNode(true));
          rows = Array.from(serialList.querySelectorAll('[data-order-bonus-serial-row]'));
        }
        while (rows.length > targetCount) {
          rows[rows.length - 1].remove();
          rows = Array.from(serialList.querySelectorAll('[data-order-bonus-serial-row]'));
        }

        rows.forEach((row, index) => {
          const number = index + 1;
          const serialInput = row.querySelector('[data-order-bonus-serial-input]');
          const serialLabel = row.querySelector('[data-order-bonus-serial-label]');
          const serialLabelText = row.querySelector('[data-order-bonus-serial-label-text]');
          const serialError = row.querySelector('[data-order-bonus-serial-error]');
          const photoInput = row.querySelector('input[type="file"]');
          const photoLabel = row.querySelector('[data-order-bonus-photo-label]');
          const photoLabelText = row.querySelector('[data-order-bonus-photo-label-text]');
          const serialId = `${form.id}-serial-${number}`;
          const serialErrorId = `${serialId}-error`;
          const photoId = `${form.id}-serial-photo-${number}`;

          if (serialInput) {
            serialInput.id = serialId;
            serialInput.setAttribute('aria-describedby', serialErrorId);
          }
          if (serialLabel) serialLabel.htmlFor = serialId;
          if (serialLabelText) serialLabelText.textContent = section.dataset.serialLabelTemplate.replace('__NUMBER__', String(number));
          if (serialError) serialError.id = serialErrorId;
          if (photoInput) photoInput.id = photoId;
          if (photoLabel) photoLabel.htmlFor = photoId;
          if (photoLabelText) photoLabelText.textContent = section.dataset.photoLabelTemplate.replace('__NUMBER__', String(number));
        });

        if (serialCount) serialCount.textContent = `${targetCount} / 10`;
        applyApplicationLockState();
      };

      const validateEmail = (showRequired = false) => {
        if (!email || !emailConfirmation) return true;

        const emailValid = validateBasicField(email, showRequired);
        let confirmationMessage = getBasicValidityMessage(emailConfirmation, showRequired);
        const emailValue = email.value.trim();
        const confirmationValue = emailConfirmation.value.trim();
        if (!confirmationMessage && confirmationValue && emailValue !== confirmationValue) {
          confirmationMessage = section.dataset.emailErrorMessage;
        }

        emailConfirmation.setCustomValidity(confirmationMessage);
        setFieldError(emailConfirmation, confirmationMessage);
        return emailValid && !confirmationMessage;
      };

      const validateSerials = (showRequired = false) => {
        const serialInputs = Array.from(form.querySelectorAll('[data-order-bonus-serial-input]'));
        const seen = new Set();
        let valid = true;

        serialInputs.forEach((input) => {
          const value = normalizeSerialValue(input.value);
          const duplicate = value && seen.has(value);
          const message = duplicate
            ? section.dataset.duplicateSerialMessage
            : showRequired && !value
              ? section.dataset.requiredInputMessage
              : '';

          input.setCustomValidity(message);
          setFieldError(input, message);
          if (message) valid = false;
          if (value) seen.add(value);
        });

        return valid;
      };

      const validateFileSize = (input, showRequired = false) => {
        if (!input || !input.files) return true;
        const oversized = Array.from(input.files).some((file) => file.size > MAX_UPLOAD_BYTES);
        const message = oversized
          ? section.dataset.fileSizeMessage
          : showRequired && input.required && !input.files.length
            ? section.dataset.requiredFileMessage
            : '';
        input.setCustomValidity(message);
        setFieldError(input, message);
        return !message;
      };

      const validateControl = (field, showRequired = false) => {
        if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) {
          return true;
        }
        if (field.type === 'hidden') return true;
        if (field === purchaseDate) return validatePurchaseDate(showRequired, showRequired);
        if (field === email || field === emailConfirmation) return validateEmail(showRequired);
        if (field.matches('[data-order-bonus-serial-input]')) return validateSerials(showRequired);
        if (field.type === 'file') return validateFileSize(field, showRequired);
        return validateBasicField(field, showRequired);
      };

      const closeModal = () => {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        document.documentElement.classList.remove('order-bonus-modal-open');
        if (lastFocusedElement) lastFocusedElement.focus();
      };

      const openModal = () => {
        if (!modal) return;
        lastFocusedElement = document.activeElement;
        modal.hidden = false;
        document.documentElement.classList.add('order-bonus-modal-open');
        const closeButton = modal.querySelector('.order-bonus__rules-close');
        if (closeButton) closeButton.focus();
      };

      const restoreSerialGuideFocus = () => {
        document.documentElement.classList.remove('order-bonus-modal-open');
        if (serialGuideLastFocusedElement) serialGuideLastFocusedElement.focus();
      };

      const closeSerialGuide = () => {
        if (!serialGuideModal || !serialGuideModal.open) return;
        serialGuideModal.close();
      };

      const openSerialGuide = (event) => {
        event.preventDefault();
        if (!serialGuideModal || serialGuideModal.open) return;
        serialGuideLastFocusedElement = document.activeElement;
        serialGuideModal.showModal();
        document.documentElement.classList.add('order-bonus-modal-open');
        if (serialGuideClose) serialGuideClose.focus();
      };

      scrollButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (formAnchor) formAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      form.addEventListener('invalid', (event) => {
        event.preventDefault();
        validateControl(event.target, true);
      }, true);

      form.addEventListener('input', (event) => {
        const field = event.target;
        if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;
        if (field === quantity) updateSerialRows();
        if (field === purchaseDate) return;
        if (
          field instanceof HTMLInputElement &&
          field.matches('[data-order-bonus-serial-input]') &&
          !event.isComposing
        ) {
          field.value = normalizeSerialValue(field.value);
        }
        const showRequired = field.dataset.orderBonusValidationShown === 'true';
        validateControl(field, showRequired);
      });

      form.addEventListener('compositionend', (event) => {
        const field = event.target;
        if (
          !(field instanceof HTMLInputElement) ||
          !field.matches('[data-order-bonus-serial-input]')
        ) return;

        field.value = normalizeSerialValue(field.value);
        validateSerials(field.dataset.orderBonusValidationShown === 'true');
      });

      form.addEventListener('change', (event) => {
        validateControl(event.target, true);
      });

      form.addEventListener('focusout', (event) => {
        const field = event.target;
        if (
          !(field instanceof HTMLInputElement) ||
          !field.matches('[data-order-bonus-serial-input]')
        ) return;

        field.value = normalizeSerialValue(field.value);
        validateSerials(true);
      });

      if (purchaseDate) {
        purchaseDate.addEventListener('click', openDateCalendar);
        purchaseDate.addEventListener('blur', () => {
          window.setTimeout(() => {
            if (dateControl && document.activeElement && dateControl.contains(document.activeElement)) return;
            validatePurchaseDate(true, true);
          }, 0);
        });
        purchaseDate.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closeDateCalendar();
            return;
          }
          if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'ArrowDown') return;
          event.preventDefault();
          openDateCalendar();
        });
      }

      if (dateToggle) dateToggle.addEventListener('click', openDateCalendar);
      if (dateCalendarPrev) {
        dateCalendarPrev.addEventListener('click', () => {
          dateView = new Date(dateView.getFullYear(), dateView.getMonth() - 1, 1);
          renderDateCalendar();
        });
      }
      if (dateCalendarNext) {
        dateCalendarNext.addEventListener('click', () => {
          dateView = new Date(dateView.getFullYear(), dateView.getMonth() + 1, 1);
          renderDateCalendar();
        });
      }

      document.addEventListener('click', (event) => {
        if (dateControl && event.target instanceof Node && dateControl.contains(event.target)) return;
        closeDateCalendar();
      });

      if (modalOpen) modalOpen.addEventListener('click', openModal);
      modalCloseButtons.forEach((button) => button.addEventListener('click', closeModal));
      if (serialGuideOpen) serialGuideOpen.addEventListener('click', openSerialGuide);
      if (serialGuideClose) serialGuideClose.addEventListener('click', closeSerialGuide);
      if (serialGuideModal) {
        serialGuideModal.addEventListener('close', restoreSerialGuideFocus);
        serialGuideModal.addEventListener('click', (event) => {
          if (event.target === serialGuideModal) closeSerialGuide();
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeDateCalendar();
        closeModal();
        closeSerialGuide();
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (isSubmitting || form.dataset.orderBonusSubmitted === 'true') return;

        if (isApplicationLocked()) {
          const applicationState = getApplicationState();
          const lockedMessage = applicationState === 'loading'
            ? section.dataset.campaignRulesLoadingMessage
            : applicationState === 'unavailable'
              ? section.dataset.campaignRulesUnavailableMessage
              : applicationState === 'closed'
                ? section.dataset.applicationClosedLabel
                : section.dataset.applicationLockedLabel;
          showResponse(lockedMessage);
          return;
        }

        let basicFieldsValid = true;
        form.querySelectorAll('input, select, textarea').forEach((field) => {
          const isSpecialField = field.type === 'hidden' ||
            field === purchaseDate ||
            field === email ||
            field === emailConfirmation ||
            field.matches('[data-order-bonus-serial-input]') ||
            field.type === 'file';
          if (!isSpecialField && !validateBasicField(field, true)) basicFieldsValid = false;
        });

        const eligible = validatePurchaseDate(true, true);
        const emailValid = validateEmail(true);
        const serialsValid = validateSerials(true);
        let filesValid = true;
        form.querySelectorAll('input[type="file"]').forEach((input) => {
          if (!validateFileSize(input, true)) filesValid = false;
        });

        if (!submissionReady) {
          showResponse(section.dataset.previewMessage);
          return;
        }

        const formValid = form.checkValidity();
        if (!basicFieldsValid || !eligible || !emailValid || !serialsValid || !filesValid || !formValid) {
          const firstInvalid = Array.from(form.querySelectorAll('input, select, textarea'))
            .find((field) => !field.checkValidity());
          if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            window.setTimeout(() => firstInvalid.focus({ preventScroll: true }), 250);
          }
          return;
        }

        const submission = collectSubmission();
        let applicationId = form.dataset.orderBonusApplicationId || createApplicationId();
        form.dataset.orderBonusApplicationId = applicationId;
        setSubmitting(true);
        showResponse(section.dataset.sendingMessage);

        try {
          const startResult = await postPayload({
            action: 'start',
            applicationId,
            fields: submission.fields,
            serials: submission.serials
          });
          applicationId = startResult.applicationId || applicationId;
          form.dataset.orderBonusApplicationId = applicationId;

          if (startResult.status !== 'submitted') {
            const uploadTasks = [];
            if (submission.proofFile) {
              uploadTasks.push({
                detailIndex: 0,
                file: submission.proofFile,
                role: 'purchase_proof'
              });
            }
            submission.serialPhotos.forEach((serialPhoto) => {
              uploadTasks.push({
                detailIndex: serialPhoto.detailIndex,
                file: serialPhoto.file,
                role: 'serial_photo'
              });
            });

            for (let index = 0; index < uploadTasks.length; index += 1) {
              showResponse(formatTemplate(section.dataset.uploadProgressTemplate, {
                __CURRENT__: index + 1,
                __TOTAL__: uploadTasks.length
              }));
              const task = uploadTasks[index];
              await uploadFile(applicationId, task.role, task.detailIndex, task.file);
            }

            await postPayload({
              action: 'finalize',
              applicationId
            });
          }

          form.dataset.orderBonusSubmitted = 'true';
          showResponse(formatTemplate(section.dataset.submissionSuccessTemplate, {
            __APPLICATION_ID__: applicationId
          }));
          if (submitButton) submitButton.textContent = section.dataset.submissionCompleteLabel;
        } catch (error) {
          if (error && error.code === 'PROCESSING_EXPIRED') {
            delete form.dataset.orderBonusApplicationId;
          }
          setSubmitting(false);
          showResponse(error instanceof Error && error.message
            ? error.message
            : section.dataset.submissionFailureMessage);
        }
      });

      updateSerialRows();
      updateCampaignDateBounds();
      applyApplicationLockState();
      validatePurchaseDate();
      loadCampaignRules();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-order-bonus-section]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    console.log(555)
    console.log($url,'$url')
    console.log(window.featuredProduct, 'window.featuredProduct')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
      console.log(666);
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    console.log(555)
    console.log($url,'$url')
    console.log(window.featuredProduct, 'window.featuredProduct')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
      console.log(666);
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    console.log(555)
    console.log($url,'$url')
    console.log(window.featuredProduct, 'window.featuredProduct')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
      console.log(666);
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rokid-report"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-rk-report-slider]';

  const initialize = (section) => {
    if (!section || section.dataset.rkReportReady === 'true') return;

    const track = section.querySelector('[data-rk-report-track]');
    const cards = track ? Array.from(track.querySelectorAll('[data-rk-report-card]')) : [];
    const previousButton = section.querySelector('[data-rk-report-prev]');
    const nextButton = section.querySelector('[data-rk-report-next]');
    const currentLabel = section.querySelector('[data-rk-report-current]');

    if (!track || cards.length === 0) return;

    let activeIndex = 0;
    let scrollFrame = null;

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(index, cards.length - 1));
      cards.forEach((card, cardIndex) => {
        if (cardIndex === activeIndex) {
          card.setAttribute('aria-current', 'true');
        } else {
          card.removeAttribute('aria-current');
        }
      });

      if (currentLabel) currentLabel.textContent = String(activeIndex + 1);
      if (previousButton) previousButton.disabled = activeIndex === 0;
      if (nextButton) nextButton.disabled = activeIndex === cards.length - 1;
    };

    const nearestCardIndex = () => {
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, cardIndex) => {
        const distance = Math.abs(card.offsetLeft - track.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = cardIndex;
        }
      });

      return nearestIndex;
    };

    const goTo = (index) => {
      const nextIndex = Math.max(0, Math.min(index, cards.length - 1));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: cards[nextIndex].offsetLeft,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
      setActive(nextIndex);
    };

    if (previousButton) previousButton.addEventListener('click', () => goTo(activeIndex - 1));
    if (nextButton) nextButton.addEventListener('click', () => goTo(activeIndex + 1));

    track.addEventListener('scroll', () => {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => setActive(nearestCardIndex()));
    }, { passive: true });

    window.addEventListener('resize', () => setActive(nearestCardIndex()), { passive: true });
    section.dataset.rkReportReady = 'true';
    setActive(0);
  };

  document.querySelectorAll(selector).forEach(initialize);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches(selector)) initialize(event.target);
    event.target.querySelectorAll(selector).forEach(initialize);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('[data-rk-report-card]');
    if (!card) return;
    card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teasing-image-tab"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
